<!-- 数字字典管理 -->
<template>
  <div class="campus-announcement" v-if="isRouterAlive">
    <!-- 数字字典管理1 -->
    <div class="oneBox">
      <div class="rightBox">
        <!-- 1用户树 -->
        <!-- <el-tree :data="dataList" :props="defaultProps" @node-click="handleNodeClick">
          <template #default="{ node, data }">
            <span class="custom-tree-node">
              <img v-if="data.children != null" src="./img/dingdan.png" alt="" class="img-box" >
              <img v-else src="./img/biaopin.png" alt="" class="img-box" >
              <span> {{ data.name }} </span>
            </span>
        </template>
        </el-tree> -->
        <el-menu default-active="1-0" class="el-menu-vertical-demo">
          <div class="el-menu-vertical-demo-item" v-for="(item, index) in dataList" :key="item.id">
            <treeNode :navIndex="index" :item="item" @menuItemClick="handleOpendw" :identification="identification">
            </treeNode>
          </div>
        </el-menu>
      </div>
      <div class="leftBox" v-if="JSON.stringify(locationData) != '{}'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="ID:" prop="numId" label-width="100px" v-if="SuboptionShow">
            <el-input v-model="ruleForm.numId"></el-input>
          </el-form-item>
          <el-form-item label="名称:" prop="userName" label-width="100px">
            <el-input v-model="ruleForm.userName"></el-input>
          </el-form-item>
          <el-form-item label="值:" prop="userValue" label-width="100px">
            <el-input v-model="ruleForm.userValue"></el-input>
          </el-form-item>
          <el-form-item label="说明:" prop="explain" label-width="100px">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="ruleForm.explain">
            </el-input>
          </el-form-item>
          <div class="fooderBtn">
            <el-button type="success" v-if="anniuTile == '详情' "
              @click="addSuboptionClick">添加子选项</el-button>
            <!-- <el-button type="primary" v-if="anniuTile=='详情' || anniuTile=='修改'" @click="">修改</el-button> -->
            <el-button type="danger" v-if="anniuTile == '详情'" @click="deleteClick">删除</el-button>
            <el-button type="primary" v-if="anniuTile == '详情' || anniuTile == '添加子选项'" @click="addClick">提交</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getDictionaryTree, menuDictionaryadd, deleteDictionary } from '@/assets/api/user.js'
// import { setSystemUserTree, } from '@/assets/api/api.js'
import treeNode from '@/views/cust-match-results/node.vue'


export default {
  components: {
    treeNode
  },
  data() {
    return {
      UparentId:'',
      ruleForm: {
        numId: '',
        userName: '',
        userValue: '',
        explain: '',
      },
      dataList: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      locationData: {},
      identification: '',
      SuboptionShow: true,
      anniuTile: '详情',
      isRouterAlive: true,
    };
  },
  created() {
    this.UserClick()
  },
  mounted() {
    this.identification = '字典'
  },
  methods: {
    addSuboptionClick() {
      this.SuboptionShow = false
      this.ruleForm.numId = ''
      this.ruleForm.userName = ''
      this.ruleForm.userValue = ''
      this.ruleForm.explain = ''
      this.anniuTile = '添加子选项'
    },
    deleteClick() {
      this.isRouterAlive = false
      deleteDictionary({id: this.locationData.id}).then((res) => {
      console.log(res, 22222222222222);
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
      this.locationData = {}
      this.$message({
        type: 'success',
        message: '删除成功'
      });
      }).catch((err) => {
        console.log(err);
      })
      console.log('删除');
    },
    handleNodeClick(data) {
      console.log(data, 456444);
    },
    UserClick() {
      getDictionaryTree().then((res) => {
        console.log(res, 22222222222222);
        this.dataList = [res.data.data]
      }).catch((err) => {
        console.log(err);
      })
    },
    //提交
    addClick() {
      this.isRouterAlive = false
      if (this.anniuTile == '详情') {
        const params = {
          id: this.ruleForm.numId,
          name: this.ruleForm.userName,
          value: this.ruleForm.userValue,
          remark: this.ruleForm.explain,
          // parentId: this.locationData.parentId
          parentId:this.UparentId
        }
        menuDictionaryadd(params).then((res) => {
          console.log(res,'修改');
          this.$nextTick(() => {
            this.isRouterAlive = true
          })
          this.$message({
            type: 'success',
            message: '修改成功'
          });
          this.locationData = {}
          this.UserClick()
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.response.data.msg
          });
        })
      } else if (this.anniuTile == '添加子选项') {
        let params = {
          // id: this.ruleForm.numId,
          name: this.ruleForm.userName,
          parentId: this.locationData.id,
          remark: this.ruleForm.explain,
          value: this.ruleForm.userValue,
          version: this.locationData.version,
          children: []
        }
        console.log(params, '新增参数');
        menuDictionaryadd(params).then((res) => {
          this.$nextTick(() => {
            this.isRouterAlive = true
          })
          this.$message({
            type: 'success',
            message: '添加子选项成功！'
          });
          this.locationData = {}
          this.UserClick()
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.response.data.msg
          });
        })
      }

    },
    handleOpendw(item) {
      this.anniuTile = '详情'
      this.SuboptionShow = true
      // console.log(5555555, item.parentId);
      this.ruleForm.numId = item.id || ''
      this.ruleForm.userName = item.name || ''
      this.ruleForm.userValue = item.value || ''
      this.ruleForm.explain = item.remark || ''
      this.locationData = item
      this.UparentId = item.parentId
      console.log('父id',  this.UparentId);
      if (item.id) {
        console.log('客户定位');
        if (item.id) {
          if (!item.zhuangtai) {
            console.log(789789);
            this.deviceUserDevice(item)
          }
          console.log(555);
        }
      }
    },
    deviceUserDevice(item) {
      item.zhuangtai = true
      let params = {
        id: item.id
      }
      getDictionaryTree(params).then((res) => {
        console.log(res, '查询用户下的设备--接口');
        if (item.children) {
          item.children = [...item.children, ...res.data.data.children]
          if (!res.data.data.children.length) {
            item.laiyuan = '1'
            this.$message({ type: 'error', message: '最后一层，没数据了!' });
          }
        } else {
          console.log([res.data.data], 111111111111111111);
          if (!res.data.data.children.length) {
            item.laiyuan = '1'
            this.$message({ type: 'error', message: '最后一层，没数据了!' });
          }
          item.children = res.data.data.children
        }
        console.log(item, '-************');
      }).catch((err) => {
        console.log(err);
      })
    },
    zhuanhuan(data) {
      return console.log(data);
    },
  },
};
</script>

<style scoped lang="scss">
.campus-announcement {
  padding-top: 5%;
  height: 100%;
  background-color: #fff;

  .oneBox {
    display: flex;
    width: 90%;
    height: 80%;
    border: 1px solid #ccc;
    margin: auto;

    // margin-top: 20px;
    .rightBox {
      width: 40%;
      height: 80%;
      overflow: auto;

      // background-color: pink;
      .img-box {
        width: 14px;
        margin-right: 4px;
      }
    }

    .leftBox {
      margin-top: 30px;
      display: flex;
      width: 100%;

      // background-color: skyblue;
      .fooderBtn {
        margin-top: 60px;
        padding-left: 40px;
      }

      /deep/ {
        .el-input--small {
          height: 30px;
          width: 300px;
        }

        // .el-button--small {
        //   margin-top: 60px;
        //   margin-left: 350px
        //   ;
        // }
      }
    }
  }
}
</style>
